module.exports = __webpack_public_path__ + "img/cdq2b40-01a.prt.78ea79a3.jpg";